/* code summary
The function loadScript takes a URL as input and loads a script onto the page only if it doesn't already exist.

First, it checks if any script on the page has the same URL as the input URL. If a script with that URL is found, the function logs a warning message to the console and returns without doing anything else.

If no script is found with the input URL, a new script element is created using document.createElement("script"), and the script's src attribute is set to the input URL. Finally, the script element is appended to the head of the document using document.head.appendChild(script), and a confirmation message is logged to the console.

Overall, this function prevents duplicate script loading on a page and ensures that a script is only loaded once.

*/

function loadScript(url) {
  // Check if script already exists on page
  var scripts = document.getElementsByTagName("script");
  for (var i = 0; i < scripts.length; i++) {
    if (scripts[i].getAttribute("src") == url) {
      console.warn("Script already exists on page:", url);
      return;
    }
  }

  // If script doesn't exist on page, create new script element and append to head
  var script = document.createElement("script");
  script.src = url;
  document.head.appendChild(script);
  console.log("Script loaded:", url);
}
